module.exports = __webpack_public_path__ + "img/glacier.7a26baa7.jpg";